// Vehicle Action Types

// List
export const LIST_VEHICLES = "LIST_VEHICLES";
export const LIST_VEHICLES_SUCCESS = "LIST_VEHICLES_SUCCESS";
export const LIST_VEHICLES_FAILURE = "LIST_VEHICLES_FAILURE";

// Create
export const CREATE_VEHICLE = "CREATE_VEHICLE";
export const CREATE_VEHICLE_SUCCESS = "CREATE_VEHICLE_SUCCESS";
export const CREATE_VEHICLE_FAILURE = "CREATE_VEHICLE_FAILURE";

// Update
export const UPDATE_VEHICLE = "UPDATE_VEHICLE";
export const UPDATE_VEHICLE_SUCCESS = "UPDATE_VEHICLE_SUCCESS";
export const UPDATE_VEHICLE_FAILURE = "UPDATE_VEHICLE_FAILURE";

// Delete
export const DELETE_VEHICLE = "DELETE_VEHICLE";
export const DELETE_VEHICLE_SUCCESS = "DELETE_VEHICLE_SUCCESS";
export const DELETE_VEHICLE_FAILURE = "DELETE_VEHICLE_FAILURE";

// Single Vehicle details
export const GET_VEHICLE_DETAILS = "GET_VEHICLE _DETAILS";
export const GET_VEHICLE_DETAILS_SUCCESS = "GET_VEHICLE _DETAILS_SUCCESS";
export const GET_VEHICLE_DETAILS_FAILURE = "GET_VEHICLE _DETAILS_FAILURE";

// Vehicle Status CRUD
export const VEHICLE_STATUS_LIST = "VEHICLE_STATUS_LIST";
export const VEHICLE_STATUS_LIST_SUCCESS = "VEHICLE_STATUS_LIST_SUCCESS";
export const VEHICLE_STATUS_LIST_FAILURE = "VEHICLE_STATUS_LIST_FAILURE";

export const VEHICLE_STATUS_CREATE = "VEHICLE_STATUS_CREATE";
export const VEHICLE_STATUS_CREATE_SUCCESS = "VEHICLE_STATUS_CREATE_SUCCESS";
export const VEHICLE_STATUS_CREATE_FAILURE = "VEHICLE_STATUS_CREATE_FAILURE";

export const VEHICLE_STATUS_UPDATE = "VEHICLE_STATUS_UPDATE";
export const VEHICLE_STATUS_UPDATE_SUCCESS = "VEHICLE_STATUS_UPDATE_SUCCESS";
export const VEHICLE_STATUS_UPDATE_FAILURE = "VEHICLE_STATUS_UPDATE_FAILURE";

export const VEHICLE_STATUS_DELETE = "VEHICLE_STATUS_DELETE";
export const VEHICLE_STATUS_DELETE_SUCCESS = "VEHICLE_STATUS_DELETE_SUCCESS";
export const VEHICLE_STATUS_DELETE_FAILURE = "VEHICLE_STATUS_DELETE_FAILURE";

// Vehicle Status Details
export const VEHICLE_STATUS_DETAILS = "VEHICLE_STATUS_DETAILS";
export const VEHICLE_STATUS_DETAILS_SUCCESS = "VEHICLE_STATUS_DETAILS_SUCCESS";
export const VEHICLE_STATUS_DETAILS_FAILURE = "VEHICLE_STATUS_DETAILS_FAILURE";

// Vehicle Type CRUD
export const VEHICLE_TYPE_LIST = "VEHICLE_TYPE_LIST";
export const VEHICLE_TYPE_LIST_SUCCESS = "VEHICLE_TYPE_LIST_SUCCESS";
export const VEHICLE_TYPE_LIST_FAILURE = "VEHICLE_TYPE_LIST_FAILURE";

export const VEHICLE_TYPE_CREATE = "VEHICLE_TYPE_CREATE";
export const VEHICLE_TYPE_CREATE_SUCCESS = "VEHICLE_TYPE_CREATE_SUCCESS";
export const VEHICLE_TYPE_CREATE_FAILURE = "VEHICLE_TYPE_CREATE_FAILURE";

export const VEHICLE_TYPE_UPDATE = "VEHICLE_TYPE_UPDATE";
export const VEHICLE_TYPE_UPDATE_SUCCESS = "VEHICLE_TYPE_UPDATE_SUCCESS";
export const VEHICLE_TYPE_UPDATE_FAILURE = "VEHICLE_TYPE_UPDATE_FAILURE";

export const VEHICLE_TYPE_DELETE = "VEHICLE_TYPE_DELETE";
export const VEHICLE_TYPE_DELETE_SUCCESS = "VEHICLE_TYPE_DELETE_SUCCESS";
export const VEHICLE_TYPE_DELETE_FAILURE = "VEHICLE_TYPE_DELETE_FAILURE";

///vehiclerecentactivity/list
export const VEHICLE_RECENT_ACTIVITY_LIST = "VEHICLE_RECENT_ACTIVITY_LIST";
export const VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS =
  "VEHICLE_RECENT_ACTIVITY_LIST_SUCCESS";
export const VEHICLE_RECENT_ACTIVITY_LIST_FAILURE =
  "VEHICLE_RECENT_ACTIVITY_LIST_FAILURE";

//vehicle/search
export const VEHICLE_SEARCH = "VEHICLE_SEARCH";
export const VEHICLE_SEARCH_SUCCESS = "VEHICLE_SEARCH_SUCCESS";
export const VEHICLE_SEARCH_FAILURE = "VEHICLE_SEARCH_FAILURE";
